module.exports = __webpack_public_path__ + "static/media/rebel.0a10efb9.svg";